module.exports = __webpack_public_path__ + "static/media/Mayow.63eebc9b.jpeg";